// Selectors
import { selectActiveEntitiesArray } from 'services/entities/selectors';
import { selectCurrentEntityId } from 'services/currentEntityId/selectors';
import { selectEntityTypeFirstDepth } from 'services/entityTypes/selectors';

// Utils
import orderBy from 'utils/custom-orderBy';
import createDeepEqualSelector from 'utils/reselect/createDeepEqualSelector';

const selectEntityTypeId = (state, props) => props.entityTypeId;
const selectIgnoreCurrentEntityId = (state, props) =>
    props.ignoreCurrentEntityId;
const selectValueIsString = (state, props) => props.valueIsString;
const selectUseCompositeKey = (state, props) => props.useCompositeKey;
const selectEntityId = (state, props) => props.entityId;

const selectFilteredData = createDeepEqualSelector(
    [
        selectActiveEntitiesArray,
        selectCurrentEntityId,
        selectEntityTypeId,
        selectEntityTypeFirstDepth,
        selectIgnoreCurrentEntityId,
        selectEntityId
    ],
    (
        activeEntitiesArray,
        currentEntityIdState,
        entityTypeIdState,
        entityTypeFirstDepthState,
        ignoreCurrentEntityIdState,
        entityIdState
    ) =>
        activeEntitiesArray.filter(value => {
            const { entityTypeId, path, id } = value;
            // Filter out entities with a different entityType
            if (entityTypeIdState && entityTypeIdState !== entityTypeId) {
                return false;
            }
            if (!entityTypeFirstDepthState && currentEntityIdState && !path) {
                return false;
            }

            if (
                !ignoreCurrentEntityIdState &&
                (currentEntityIdState &&
                    !(
                        `${path}/`.includes(`/${currentEntityIdState}/`) ||
                        id === currentEntityIdState
                    ))
            ) {
                return false;
            }

            if (
                entityIdState &&
                !(
                    `${path}/`.includes(`/${entityIdState}/`) ||
                    id === entityIdState
                )
            ) {
                return false;
            }

            return true;
        })
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredData => orderBy(filteredData, 'pathNames')
);

const makeSelectOptions = () =>
    createDeepEqualSelector(
        [selectOrderedData, selectValueIsString, selectUseCompositeKey],
        (orderedDataState, valueIsStringProp, useCompositeKeyProp) =>
            orderedDataState &&
            orderedDataState.map(({ id, pathNames, entityTypeId }) => {
                if (valueIsStringProp) {
                    return {
                        key: id,
                        text: pathNames,
                        value: `${id}`
                    };
                }
                if (useCompositeKeyProp) {
                    return {
                        key: id,
                        text: pathNames,
                        value: `${id}.${entityTypeId}`
                    };
                }

                return {
                    key: id,
                    text: pathNames,
                    value: id
                };
            })
    );

export { makeSelectOptions };
